import { render, staticRenderFns } from "./DiscoveryPageSingleAdd.vue?vue&type=template&id=10285402&scoped=true&"
import script from "./DiscoveryPageSingleAdd.vue?vue&type=script&lang=js&"
export * from "./DiscoveryPageSingleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10285402",
  null
  
)

export default component.exports